<template>
  <div class="content">
    <div class="ebf-shell">
      <form class="form-horizontal" @submit.prevent="onSubmit">
        <card class="text-left ebf-card">
          <template slot="header">
            <h4 class="card-title">{{ bannerId ? "배너 상세" : "배너 등록" }}</h4>
          </template>

          <!-- 이미지 -->
          <section class="ebf-section">
            <h5 class="ebf-section-title">이미지</h5>
            <div class="row ebf-image-row">
              <div class="col-lg-4 col-md-6 ebf-image-field">
                <label>한국어 이미지 <span class="ebf-required" aria-hidden="true">*</span></label>
                <div class="ebf-image-upload">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ebf-image-field">
                <label>영어 이미지</label>
                <div class="ebf-image-upload">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnUrl" @onChangeFileIds="onFileIdEnChange" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 ebf-image-field">
                <label>일본어 이미지</label>
                <div class="ebf-image-upload">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaUrl" @onChangeFileIds="onFileIdJaChange" />
                </div>
              </div>
            </div>
          </section>

          <!-- 기본 설정 -->
          <section class="ebf-section">
            <h5 class="ebf-section-title">기본 설정</h5>
            <div class="ebf-grid">
              <div class="ebf-field ebf-field-wide">
                <label>제목</label>
                <div class="ebf-title-row">
                  <base-input placeholder="한국어 제목" v-model="title">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                  <base-input placeholder="영어 제목" v-model="titleEn">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                  <base-input placeholder="일본어 제목" v-model="titleJa">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="ebf-field">
                <label>링크 옵션</label>
                <LinkSelect @linkChangeEvent="getLink" link-model="link" class="ebf-link-select" />
              </div>
              <div class="ebf-field">
                <label>노출타입 <span class="ebf-required" aria-hidden="true">*</span></label>
                <el-select v-if="bannerId" size="large" class="select-primary" placeholder="선택" v-model="type">
                  <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
                </el-select>
                <el-select v-else size="large" class="select-primary" placeholder="선택" v-model="type" multiple>
                  <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
                </el-select>
              </div>
              <div class="ebf-field ebf-field-wide">
                <label class="ebf-link-label">
                  <span>링크</span>
                  <span class="badge badge-pill" :class="hasLink ? 'badge-success' : 'badge-secondary'">
                    {{ hasLink ? "설정됨" : "미설정" }}
                  </span>
                </label>
                <base-input placeholder="링크를 입력하거나 위에서 선택하세요" v-model="link">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </section>

          <!-- 노출 기간 -->
          <section class="ebf-section">
            <h5 class="ebf-section-title">노출 기간</h5>
            <div class="ebf-grid">
              <div class="ebf-field">
                <label>노출 시작 시간 <span class="ebf-required" aria-hidden="true">*</span></label>
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
              <div class="ebf-field">
                <label>노출 종료 시간 <span class="ebf-required" aria-hidden="true">*</span></label>
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </section>

          <!-- 노출 대상 -->
          <section class="ebf-section ebf-target-section">
            <h5 class="ebf-section-title">노출 대상</h5>
            <div class="ebf-target-grid">
              <div class="ebf-target-col">
                <div class="ebf-target-heading">
                  <div>
                    <h6>노출 아티스트 <span class="ebf-required" aria-hidden="true">*</span></h6>
                    <span class="ebf-target-summary">{{ selectedUnitIds.length > 0 ? `${selectedUnitIds.length}개 선택` : "선택 없음" }}</span>
                  </div>
                </div>
                <el-select v-model="selectedUnitIds" class="ebf-target-select" placeholder="아티스트 검색 및 선택" multiple filterable clearable collapse-tags>
                  <el-option v-for="unit in units" :key="unit.unitId" :label="unit.blipName" :value="unit.unitId" />
                </el-select>
                <div class="ebf-target-selected">
                  <div class="ebf-target-selected-heading">
                    <span>선택된 아티스트</span>
                    <span>{{ selectedUnits.length }}개</span>
                  </div>
                  <div v-if="selectedUnits.length" class="ebf-target-tags">
                    <el-tag v-for="unit in selectedUnits" :key="unit.value" closable size="small" @close="removeUnit(unit.value)">
                      {{ unit.label }}
                    </el-tag>
                  </div>
                  <div v-else class="ebf-target-empty">아티스트를 검색해 노출 대상을 선택해 주세요.</div>
                </div>
              </div>
              <div class="ebf-target-col">
                <div class="ebf-target-heading">
                  <div>
                    <h6>노출 국가</h6>
                    <span class="ebf-target-summary">{{ selectedCountryCodes.length > 0 ? `${selectedCountryCodes.length}개 선택` : "전체" }}</span>
                  </div>
                </div>
                <el-select v-model="selectedCountryCodes" class="ebf-target-select" placeholder="국가 검색 및 선택" multiple filterable clearable collapse-tags>
                  <el-option v-for="country in countryCodes" :key="country.isoCode" :label="country.name" :value="country.isoCode" />
                </el-select>
                <div class="ebf-target-selected">
                  <div class="ebf-target-selected-heading">
                    <span>선택된 국가</span>
                    <span>{{ selectedCountries.length }}개</span>
                  </div>
                  <div v-if="selectedCountries.length" class="ebf-target-tags">
                    <el-tag v-for="country in selectedCountries" :key="country.value" closable size="small" @close="removeCountry(country.value)">
                      {{ country.label }}
                    </el-tag>
                  </div>
                  <div v-else class="ebf-target-empty">비우면 전체 국가에 노출됩니다.</div>
                </div>
              </div>
            </div>
          </section>
        </card>

        <div class="ebf-actions">
          <base-button native-type="submit" type="success">{{ bannerId ? "수정" : "등록" }}</base-button>
          <base-button @click="goBack" type="default">취소</base-button>
          <base-button v-if="bannerId && state === 0" @click="setBannerState(1)" type="default">표시</base-button>
          <base-button v-if="bannerId && state === 1" @click="setBannerState(0)" type="default">숨김</base-button>
          <base-button v-if="bannerId" @click="setBannerState(-1)" type="danger">삭제</base-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { Toast } from "@/util/Toast";
import LinkSelect from "@/pages/Components/LinkSelect.vue";

export default {
  components: {
    Card,
    BaseInput,
    LinkSelect,
    BlipFileUploadZone,
  },
  async created() {
    await this.getAllUnits();
    await this.getCountryCodes();
    if (this.$route.query.bannerId) {
      this.bannerId = Number(this.$route.query.bannerId);
      await this.getData();
    }
  },
  data() {
    return {
      bannerId: null,
      description: null,
      imageFileId: null,
      imageFileUrl: null,
      imageFileEnId: null,
      imageFileEnUrl: null,
      imageFileJaId: null,
      imageFileJaUrl: null,
      title: null,
      titleEn: null,
      titleJa: null,
      link: null,
      startTime: null,
      endTime: null,
      units: [],
      selectedUnitIds: [],
      type: 0,
      state: 1,
      countryCodes: [],
      selectedCountryCodes: [],
      types: [
        { type: 0, name: "메인 중단", namespace: 600, position: 2 },
        { type: 1, name: "타임라인 중단", namespace: 1500, position: 2 },
        { type: 2, name: "알림 상단", namespace: 20, position: 1 },
      ],
    };
  },
  computed: {
    selectedUnits() {
      return this.selectedUnitIds.map((unitId) => {
        const unit = this.units.find((u) => u.unitId === unitId);
        return { value: unitId, label: unit ? unit.blipName : String(unitId) };
      });
    },
    selectedCountries() {
      return this.selectedCountryCodes.map((code) => {
        const country = this.countryCodes.find((c) => c.isoCode === code);
        return { value: code, label: country ? country.name : code };
      });
    },
    hasLink() {
      return Boolean(this.link && this.link.trim());
    },
  },
  methods: {
    removeUnit(unitId) {
      this.selectedUnitIds = this.selectedUnitIds.filter((id) => id !== unitId);
    },
    removeCountry(code) {
      this.selectedCountryCodes = this.selectedCountryCodes.filter((c) => c !== code);
    },
    async getCountryCodes() {
      return this.$axios.get(`/common/countryCodes`).then((res) => {
        this.countryCodes = res.data.data || [];
      });
    },
    async getAllUnits() {
      return this.$axios.get(`/artistUnit`).then((res) => {
        const seen = new Set();
        this.units = (res.data.data || []).filter((u) => {
          if (seen.has(u.unitId)) return false;
          seen.add(u.unitId);
          return true;
        });
      });
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onFileIdEnChange(newFileIds) {
      this.imageFileEnId = newFileIds[0];
    },
    onFileIdJaChange(newFileIds) {
      this.imageFileJaId = newFileIds[0];
    },
    async getData() {
      return this.$axios.get(`/eventBanner/${this.bannerId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.title = data.title;
          this.titleEn = data.titleEn;
          this.titleJa = data.titleJa;
          this.imageFileId = data.imageFileId;
          this.imageFileEnId = data.imageFileEnId;
          this.imageFileJaId = data.imageFileJaId;
          this.link = data.link;
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.state = data.state;
          this.type = this.types.find((t) => t.namespace === data.namespace && t.position === data.position)?.type ?? 0;
          if (this.imageFileId) this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          if (this.imageFileEnId) this.imageFileEnUrl = window.Endpoints.imageServerUrl + this.imageFileEnId;
          if (this.imageFileJaId) this.imageFileJaUrl = window.Endpoints.imageServerUrl + this.imageFileJaId;
          this.selectedUnitIds = data.unitIds ? [...new Set(data.unitIds.split(",").map(Number))] : [];
          this.selectedCountryCodes = data.countryCodes ? data.countryCodes.split(",").map((c) => c.trim()) : [];
        }
      });
    },
    async setBannerState(state) {
      return this.$axios.put(`/eventBanner/${this.bannerId}/state`, { params: { state } }).then(() => {
        Toast.success("상태가 변경되었습니다");
        this.state = state;
      });
    },
    getLink(param) {
      const linkModel = param.linkModel.split(".");
      this[linkModel[0]] = param.value;
    },
    async onSubmit() {
      if (!this.imageFileId && !this.imageFileUrl) {
        Toast.error("한국어 이미지는 필수입니다");
        return;
      }
      if (!this.startTime || !this.endTime) {
        Toast.error("시간을 입력해주세요");
        return;
      }
      if (new Date(this.startTime) > new Date(this.endTime)) {
        Toast.error("종료시간이 시작시간보다 빨라요");
        return;
      }
      if (this.selectedUnitIds.length === 0) {
        Toast.error("아티스트를 선택해주세요");
        return;
      }
      const params = {
        title: this.title,
        titleEn: this.titleEn,
        titleJa: this.titleJa,
        description: this.description,
        imageFileId: this.imageFileId,
        imageFileEnId: this.imageFileEnId,
        imageFileJaId: this.imageFileJaId,
        link: this.link,
        namespace: null,
        position: null,
        startTime: this.startTime,
        endTime: this.endTime,
        units: this.selectedUnitIds,
        countryCodes: this.selectedCountryCodes.length > 0 ? this.selectedCountryCodes.toString() : null,
      };

      if (this.bannerId) {
        const type = this.types.find((t) => t.type === this.type);
        params.namespace = type.namespace;
        params.position = type.position;
        await this.$axios.put(`/eventBanner/${this.bannerId}`, { params });
        Toast.success("배너가 수정되었습니다");
      } else {
        for (const t of this.type) {
          const type = this.types.find((tp) => tp.type === t);
          params.namespace = type.namespace;
          params.position = type.position;
          await this.$axios.post("/eventBanner", { params });
        }
        Toast.success("배너가 등록되었습니다");
      }
      this.goBack();
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.ebf-shell {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

.ebf-card {
  overflow: hidden;
}

.ebf-card .card-title {
  margin: 0;
}

/* 섹션 */
.ebf-section {
  padding: 28px 0;
  border-top: 1px solid rgba(34, 42, 66, 0.12);
}

.ebf-section:first-child {
  padding-top: 8px;
  border-top: 0;
}

.ebf-section-title {
  margin: 0 0 18px;
  color: #32325d;
  font-size: 1rem;
  font-weight: 700;
}

.ebf-required {
  margin-left: 2px;
  color: #f5365c;
}

/* 이미지 */
.ebf-image-row {
  row-gap: 24px;
}

.ebf-image-field label {
  display: block;
  margin-bottom: 8px;
  color: #525f7f;
  font-size: 0.78rem;
  font-weight: 700;
}

.ebf-image-upload {
  width: 100%;
  overflow: hidden;
  border: 1px solid #e3e6ed;
  border-radius: 4px;
  background: #f7f8fa;
}

.ebf-image-upload::v-deep .dropzone {
  display: flex;
  width: 100%;
  min-height: 0;
  aspect-ratio: 4 / 3;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 0;
  background: transparent;
}

.ebf-image-upload::v-deep .dropzone > div:not(.dz-preview) {
  width: 100%;
  height: 100%;
}

.ebf-image-upload::v-deep .dropzone img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 기본 설정 그리드 */
.ebf-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 28px;
}

.ebf-field {
  min-width: 0;
}

.ebf-field-wide {
  grid-column: 1 / -1;
}

.ebf-title-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.ebf-link-select {
  display: block;
  width: 100%;
}

.ebf-link-label {
  display: flex !important;
  gap: 8px;
  align-items: center;

  .badge {
    flex: 0 0 auto;
    white-space: nowrap;
  }
}

.ebf-field > label {
  display: block;
  margin-bottom: 8px;
  color: #525f7f;
  font-size: 0.78rem;
  font-weight: 700;
}

.ebf-field::v-deep .form-group,
.ebf-field::v-deep .el-select,
.ebf-field::v-deep .el-date-editor,
.ebf-field::v-deep .el-date-editor.el-input {
  width: 100%;
  margin-bottom: 0;
}

/* 노출 대상 */
.ebf-target-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #e3e6ed;
  border-bottom: 1px solid #e3e6ed;
}

.ebf-target-col {
  min-width: 0;
  padding: 20px 24px;
}

.ebf-target-col + .ebf-target-col {
  border-left: 1px solid #e3e6ed;
}

.ebf-target-heading {
  display: flex;
  min-height: 46px;
  gap: 20px;
  align-items: flex-start;
  justify-content: space-between;
}

.ebf-target-heading h6 {
  margin: 0 0 4px;
  color: #32325d;
  font-size: 0.88rem;
  font-weight: 700;
}

.ebf-target-summary {
  color: #8898aa;
  font-size: 0.76rem;
  font-weight: 600;
}

.ebf-target-select {
  width: 100%;
  margin-top: 14px;
}

.ebf-target-select::v-deep .el-input__inner {
  min-height: 42px;
}

.ebf-target-selected {
  margin-top: 10px;
  padding: 12px;
  border: 1px solid #e3e6ed;
  border-radius: 4px;
  background: #f7f8fa;
}

.ebf-target-selected-heading {
  display: flex;
  margin-bottom: 9px;
  color: #525f7f;
  font-size: 0.74rem;
  font-weight: 700;
  justify-content: space-between;

  span:last-child {
    color: #8898aa;
  }
}

.ebf-target-tags {
  display: flex;
  max-height: 112px;
  padding-right: 4px;
  overflow-y: auto;
  flex-wrap: wrap;
  gap: 6px;
}

.ebf-target-tags::v-deep .el-tag {
  max-width: 100%;
}

.ebf-target-tags::v-deep .el-tag__close {
  flex: 0 0 auto;
}

.ebf-target-empty {
  min-height: 28px;
  color: #8898aa;
  font-size: 0.76rem;
  line-height: 28px;
}

/* 하단 액션 */
.ebf-actions {
  display: flex;
  padding: 4px 0 24px;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

@media (max-width: 991px) {
  .ebf-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .ebf-field-wide {
    grid-column: auto;
  }

  .ebf-target-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .ebf-target-col + .ebf-target-col {
    border-top: 1px solid #e3e6ed;
    border-left: 0;
  }
}

@media (max-width: 575px) {
  .ebf-target-heading {
    flex-direction: column;
    gap: 10px;
  }

  .ebf-actions .btn {
    flex: 1 1 calc(50% - 8px);
  }
}
</style>
